import Head from "next/head";

export default function METATAGSEO({
  description,
  title,
  canonicalUrl,
  altText,
  keywords,
  OgImageUrl,
  ogType,
}) {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="canonical" href={canonicalUrl} />
      <meta name="theme-color" content="#000000" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={OgImageUrl} />
      <meta property="og:image:alt" content={altText} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content="QuickTor - מערכת לניהול תורים" />
      <meta property="og:type" content={ogType ? ogType : "website"} />
      <meta property="og:locale" content="he_IL" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OgImageUrl} />

      <meta name="copyright" content="QuickTor" />
      <meta name="author" content="Din roda" />
      <meta property="article:section" content="ניהול תורים" />
      <meta property="article:tag" content="ניהול תורים" />
      <meta property="article:tag" content="תזכורות לתורים" />
      <meta property="article:tag" content="יומן לקוחות"/>
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/favicon-16x16.png"
      />
      {/* <meta name="p:domain_verify" content="95d8d74bae0712e9d9ad8c3281f1283b" /> */}
      {/* <meta
        name="facebook-domain-verification"
        content="7mdup0iqy13ng89l4imdtl241i9o4s"
      /> */}
      <meta
        name="robots"
        content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
      />
    </Head>
  );
}

METATAGSEO.defaultProps = {
  lang: `he`,
  // meta: [],
  // description: `שולחן עמידה ארגונומי מתכוונן חשמלי במחיר מצויין`,
};
